/**
 * Attempt to create a URL object from a string, and throw an informative error if it fails.
 * (The URL constructor throws a very generic error.)
 */
export function makeUrl(input: string, base?: string | URL): URL {
  try {
    // eslint-disable-next-line no-restricted-syntax -- this is the function definition
    return new URL(input, base);
  } catch {
    throw new Error(`Invalid URL: "${input}", base: "${base || ''}"`);
  }
}
